import React from 'react';
import {fetchUtils, AutocompleteArrayInput, ReferenceArrayInput, SelectInput, Button, TabbedForm, FormTab, Filter, required, Toolbar, SaveButton,
	DateField, Edit, Create, List, Datagrid, TextField, TextInput, DateInput, SelectArrayInput, FormDataConsumer } from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/conversions_report';

const choicesInterval = [
	{ id: 'hour', name: 'Hourly' },
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: 0, name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
	{ id: 'custom', name: 'Custom' }
];
// Three domain dimensions, because they are three different things. "Publisher
// Domain" is where the ad was clicked and is carried from the click; the other
// two are the advertiser's own site, where the tag fired. Labelled explicitly
// so nobody reads tldomain here the way they read it on the clicks report.
const choicesShowCommon = [
	{ id: 'date', name: 'Date' },
	{ id: 'attributed', name: 'Attributed' },
	{ id: 'click_fraud', name: 'Fraudulent Click' },
	{ id: 'campaign', name: 'Campaign' },
	{ id: 'creative', name: 'Creative' },
	{ id: 'advertiser', name: 'Advertiser' },
	{ id: 'audience_code', name: 'Tag ID' },
	{ id: 'tldomain', name: 'Publisher Domain' },
	{ id: 'adomain', name: 'Advertiser Domain' },
	{ id: 'conversion_domain', name: 'Conversion Page Domain' },
	{ id: 'adsize', name: 'Ad Size' },
	{ id: 'ad_type', name: 'Ad Type' },
	{ id: 'device', name: 'Device' },
	{ id: 'browser', name: 'Browser' },
	{ id: 'country', name: 'Country' },
	{ id: 'city', name: 'City' },
	{ id: 'state', name: 'State' },
	{ id: 'user_ip', name: 'User IP' },
	{ id: 'user_zip', name: 'User ZIP' },
	{ id: 'order_id', name: 'Order ID' }
];
// NBU-5 supply-side identity: admins only. The real boundary is server-side in
// service/reporter/misc_reports.js, which strips these from both the SELECT and
// the WHERE regardless of what the client sends -- this list only keeps the UI
// from offering checkboxes that would silently do nothing.
const choicesShowSupplySide = [
	{ id: 'publisher', name: 'Publisher' },
	{ id: 'site', name: 'Site' },
	{ id: 'bidder', name: 'Bidder' }
];
const choicesShow = (permissions) =>
	(permissions && permissions.role === 'advertiser')
		? choicesShowCommon
		: [...choicesShowCommon, ...choicesShowSupplySide];
const ConversionsTitle = ({ record }) => {
	return <span>Conversions Report {record ? `"${record.name}"` : ''}</span>;
};
const ConversionsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const ConversionsList = (props) => (
	<List {...props} title="Conversions Reports" perPage={25} bulkActionButtons={false} filters={<ConversionsFilter />}
	exporter={false} >
		<Datagrid rowClick="edit">
			<TextField source="name" label="Name" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
class CustomToolbar extends React.Component {
	state = {
	}
	constructor(props) {
		super(props);
		this.parent = props.parent;
	}
	fetchData() {
		let show='';
		if (formData.show) formData.show.map(item => { show+='&show='+item; });
		let interval = (formData.interval)?`&interval=${formData.interval}`:'&interval=day';
		let dateRange = '';
		if ('custom'===formData.date_range) {
			dateRange = `&start_date=${formData.start_date}&end_date=${formData.end_date}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

		this.parent.setState({loading: true, total: '---'});
		let url = `${BASE_URL}?r=1${show}${interval}${dateRange}`+
		`${utils.formDataFieldsQueryStringFormat(formData, ['campaign_id', 'creative_id', 'advertiser_id', 'tldomain',
		'adomain', 'conversion_domain', 'device', 'adsize', 'ad_type', 'attributed', 'click_fraud', 'audience_code',
		'country', 'order_id'])}`;
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		fetch(url, options).then(({ headers, json }) => (
			this.parent.setState({data: json.data, loading: false, total: json.total})
		));
	}
	handleSearch = (props) => {
		this.fetchData();
	}
	render() {
		return <Toolbar>
			<SaveButton style={{marginRight: '10px'}} variant='contained'
				color='primary' disabled={this.props.parent.state.loading} {...this.props}/>
			<br />
			<Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary'
				startIcon={<RunReportIcon />} style={{padding: '7px', width: '160px'}}
				disabled={this.props.parent.state.loading} />
			<br />
			<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
			<TextField source="updated_name" label="" style={{ padding: '10px' }} />
		</Toolbar>
	}
};
let formData = {};
function setFormData(formdata) {
	formData = formdata;
}
class ConversionsForm extends React.Component {
	state = {};
	render() {
		return (
			<TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
			<FormTab label="Report Settings">
				<TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
				<FormDataConsumer>
					{({ formData }) => setFormData(formData) }
				</FormDataConsumer>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper2">
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Interval" source="interval"
						choices={choicesInterval}
						defaultValue='day'
						disabled={this.props.parent.loading} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Date Range" source="date_range"
						choices={dateRangeChoices}
						onChange={value => this.setState({ date_range: value.target.value })}
						defaultValue="8"
						disabled={this.props.parent.loading} />

						<div style={{ float: 'right', paddingLeft: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
						<div style={{ float: 'left', paddingRight: '5px', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="Start Date" source="start_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
						</div>

						<div style={{ float: 'left', display: ('custom' != this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="End Date" source="end_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' != this.state.date_range) ? 'none' : 'block' }} />
						</div>
						</div>
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectArrayInput label="Show"
						source="show"
						choices={choicesShow(this.props.parent.props.permissions)}
						defaultValue={['date', 'campaign', 'attributed']}
						style={{ width: '400px' }}
						disabled={this.props.parent.loading} />
					</div>
				</div>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
					<div style={{ float: 'left', paddingRight: '10px' }}>
					<TextInput source="adomain" label="Advertiser Domain" style={{ width: '300px' }} />
					</div>
					<div style={{ float: 'left', paddingRight: '10px' }}>
					<TextInput source="tldomain" label="Publisher Domain / App" style={{ width: '300px' }} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectInput label="Attribution"
					source="attributed"
					choices={[
						{ id: '', name: 'All Conversions' },
						{ id: 'true', name: 'Attributed Only' },
						{ id: 'false', name: 'Unattributed Only' },
					]}
					defaultValue='' />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
					{/* Mirrors the clicks report's fraud selector. Defaults to
					    ALL rather than non-fraud only: on the clicks report
					    fraud is common enough to want hidden by default, but a
					    fraudulent conversion is rare and is the more
					    interesting row when it happens. */}
					<SelectInput label="Click Fraud"
					source="click_fraud"
					choices={[
						{ id: '', name: 'All Conversions' },
						{ id: 'false', name: 'Clean Clicks Only' },
						{ id: 'true', name: 'Fraudulent Clicks Only' },
					]}
					defaultValue='' />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput label="Campaign"
						perPage={15}
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ type:'DIRECT', search_name: searchText })}
						source="campaign_id"
						reference="adcampaigns"
						basePath='adcampaigns'>
						<AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
						optionValue='code' style={{ width: '200px' }}/>
					</ReferenceArrayInput>
					</div>
				</div>
			</FormTab>
			</TabbedForm>
		)
	}
}
let BASE_COLUMNS = [
	{ name: 'Date', selector: 'date', sortable: true, cell: row => ('' + row.date) },
	{ name: 'Attributed', selector: 'attributed', sortable: true, cell: row => <span>{ ''+row.attributed }</span> },
	// Rendered as a dash, not "false", when the row is known to be unattributed.
	// The underlying column is tri-state: the adserver omits the flag when there
	// was no click, so it falls to its default of false and "false" would read
	// as "the click was clean" when in fact there was no click to judge. We can
	// only tell them apart when `attributed` is also grouped, which the default
	// Show selection does.
	{ name: 'Fraudulent Click', selector: 'click_fraud', sortable: true,
		cell: row => <span>{ row.attributed === false || row.attributed === 'false' ? '\u2014' : ''+row.click_fraud }</span> },
	{ name: 'Campaign ID', selector: 'campaign_id', sortable: true },
	{ name: 'Campaign Name', selector: 'campaign_name', sortable: true },
	{ name: 'Creative ID', selector: 'creative_id', sortable: true },
	{ name: 'Creative Name', selector: 'creative_name', sortable: true },
	// The identifier the advertiser pasted into their own tag. Usually redundant
	// next to Advertiser Name - except on unattributed rows, where it is the only
	// thing saying whose conversion this is.
	{ name: 'Tag ID', selector: 'audience_code', sortable: true },
	{ name: 'Advertiser ID', selector: 'advertiser_id', sortable: true },
	{ name: 'Advertiser Name', selector: 'advertiser_name', sortable: true },
	{ name: 'Publisher ID', selector: 'publisher_id', sortable: true },
	{ name: 'Publisher Name', selector: 'publisher_name', sortable: true },
	{ name: 'Site ID', selector: 'site_id', sortable: true },
	{ name: 'Site Name', selector: 'site_name', sortable: true },
	{ name: 'Bidder ID', selector: 'bidder_id', sortable: true },
	{ name: 'Bidder Name', selector: 'bidder_name', sortable: true },
	{ name: 'Publisher Domain', selector: 'tldomain', sortable: true },
	{ name: 'Advertiser Domain', selector: 'adomain', sortable: true },
	{ name: 'Conversion Page Domain', selector: 'conversion_domain', sortable: true },
	{ name: 'Ad Size', selector: 'adsize', sortable: true },
	{ name: 'Ad Type', selector: 'ad_type', sortable: true },
	{ name: 'Device', selector: 'device', sortable: true },
	{ name: 'Browser', selector: 'browser', sortable: true },
	{ name: 'Country', selector: 'country', sortable: true },
	{ name: 'City', selector: 'city', sortable: true },
	{ name: 'State', selector: 'state', sortable: true },
	{ name: 'User Zip', selector: 'user_zip', sortable: true },
	{ name: 'User IP', selector: 'user_ip', sortable: true },
	{ name: 'Order ID', selector: 'order_id', sortable: true },
	{ name: 'Conversions', selector: 'total', sortable: true, cell: row => utils.formatLong(row.total) },
	// Currency is always present: the server forces it into every grouping so
	// this column is never a sum across different currencies.
	{ name: 'Currency', selector: 'currency', sortable: true },
	{ name: 'Value', selector: 'value', sortable: true, cell: row => utils.formatDouble(row.value) },
	{ name: 'Avg Hours To Convert', selector: 'avg_hours_to_convert', sortable: true, cell: row => utils.formatDouble(row.avg_hours_to_convert) }
];
let columns = [];
class ConversionsUpsert extends React.Component {
	state = {
		data: [],
		loading: false,
		total: '---'
	};
	constructor(props) {
		super(props);
	}
	setState(obj) {
		if (obj.data && obj.data.length>0) {
			let keys = Object.keys(obj.data[0]);
			columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
		}
		super.setState(obj);
	}
	render(props) {
		const { data, loading, total } = this.state;
		return (
		<div>
			{this.props.formType === "edit" &&
				<Edit title={<ConversionsTitle />} {...this.props}>
					<ConversionsForm formType="edit" parent={this}/>
				</Edit>
			}
			{this.props.formType === "create" &&
				<Create title="Create Conversions Report" {...this.props}>
					<ConversionsForm formType="create" parent={this}/>
				</Create>
			}
			<DataTable
				title={`${total} Matching Results`}
				theme={window.nobid_table_theme()}
				columns={columns}
				data={data}
				progressPending={loading}
				pagination
				fixedHeader
				dense
				paginationPerPage={30}
				paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
				subHeader={!loading}
				subHeaderComponent={
					(
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input type="text" id='search_box' label="Search"
						variant="outlined"
						style={{ margin: '5px' }}
						onChange={(target) => dataSupport.filterData(this)} />
						<CloudDownload
						label="Export"
						style={{ margin: '5px' }}
						color="action"
						onClick={() => dataSupport.exportData(this.state.data)}
						/>
					</div>
					)
				}
			/>
		</div>
		)
	}
}

export const ConversionsEdit = (props) => (
	<ConversionsUpsert formType="edit" permissions={props.permissions} {...props} />
);

export const ConversionsCreate = (props) => (
	<ConversionsUpsert formType="create" permissions={props.permissions} {...props} />
);
